import { create } from "zustand";
import axiosClient from "../axiosClient";

interface AuthStatusStore {
  isLoggedIn: boolean;
  setIsLoggedIn: (val: boolean) => void;
  logout: () => Promise<void>;
}

export const useAuthStatus = create<AuthStatusStore>((set) => ({
  isLoggedIn: false,
  setIsLoggedIn: (val: boolean) => set(() => ({ isLoggedIn: val })),
  logout: async () => {
    await axiosClient.post(`/auth/logout`, {});
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    set(() => ({ isLoggedIn: false }));
  },
}));
